import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-red-600 border border-red-600 my-[10px] text-white text-center fixed md:top-[80px] top-[60px] shadow-lg left-[50%] translate-x-[-50%] font-bold flex justify-center items-center z-30 rounded-[5px] max-w-[650px] w-[90%] p-[20px]"
}
const _hoisted_2 = { class: "text-gray-600 flex relative text-sm bg-white border border-gray-400 p-[10px] w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", { class: "items-center p-[5px] flex w-[25px]" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "checkbox",
    name: "news-checkbox-{{ newsDetail.id }}",
    id: "news-checkbox-{{ newsDetail.id }}"
  })
], -1)
const _hoisted_4 = { class: "items-center p-[5px] flex w-[25px]" }
const _hoisted_5 = { class: "items-center md:w-[calc(100%/6)] w-[calc(100%/3)] p-[5px] flex" }
const _hoisted_6 = { class: "items-center md:w-[calc(100%/6)] w-[calc(100%/3)] p-[5px] hidden text-justify" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "items-center md:w-[calc(100%/6)] w-[calc(100%/3)] p-[5px] flex" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "items-center md:w-[calc(100%/6)] w-[calc(100%/3)] overflow-x-auto p-[5px] md:flex hidden" }
const _hoisted_11 = { class: "items-center md:w-[calc(100%/6)] w-[calc(100%/3)] p-[5px] md:flex justify-center flex-wrap hidden" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  class: "fixed top-0 left-0 w-full h-full flex justify-center items-center bg-gray-800 bg-opacity-50"
}
const _hoisted_15 = { class: "bg-white p-8 rounded-lg" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold mb-4" }, "Confirmez la suppression du news", -1)

import NewsDetail from '@/components/types/NewsDetail'
    import axios from 'axios';
    import { useRouter } from 'vue-router';
    import axiosInstance from '@/plugins/axios';
    
    import { ref } from 'vue';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'rowNews',
  props: {
    news: {}
  },
  setup(__props: any) {

    const router = useRouter();
    const errorMessage = ref("");
    
    const props = __props;


const showConfirmationModal = ref(false);
const selectedNewsDetail = ref<NewsDetail | null>(null);

const confirmDelete = (newsDetail: NewsDetail) => {
  selectedNewsDetail.value = newsDetail;
  showConfirmationModal.value = true;
};

const deleteNews = async () => {
  if (!selectedNewsDetail.value) return;

  try {
    const token = localStorage.getItem('token');
    if (!token) return;

    const response = await axiosInstance.delete(`/news/${selectedNewsDetail.value.id}/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200 || response.status === 204) {
      window.location.reload();
    }
  } catch (error) {
    errorMessage.value = 'Erreur lors de la suppression du news: Vous n\'avez pas les autorisations requises';
    hideErrorMessageAfterDelay();
  } finally {
    selectedNewsDetail.value = null;
    showConfirmationModal.value = false;
  }
};

const confirmUpdate = (newsDetail: NewsDetail) => {
  selectedNewsDetail.value = newsDetail;
  router.push({ name: 'AddAnNewsWith', params: { id: newsDetail.id } });
};


const cancelDelete = () => {
  selectedNewsDetail.value = null;
  showConfirmationModal.value = false;
};

const hideErrorMessageAfterDelay = () => {
  setTimeout(() => {
    errorMessage.value = ''; 
  }, 5000);
};
    



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.news, (newsDetail) => {
      return (_openBlock(), _createElementBlock("tr", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("td", _hoisted_4, _toDisplayString(newsDetail.id), 1),
        _createElementVNode("td", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: { name: 'news', params: { id: newsDetail.id }},
            class: "hover:text-black hover:underline duration-300"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(newsDetail.title), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        _createElementVNode("td", _hoisted_6, [
          _createElementVNode("div", {
            innerHTML: newsDetail.texte
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("td", _hoisted_8, [
          _createElementVNode("img", {
            src: newsDetail.image,
            class: "w-full",
            alt: ""
          }, null, 8, _hoisted_9)
        ]),
        _createElementVNode("td", _hoisted_10, _toDisplayString(newsDetail.date), 1),
        _createElementVNode("td", _hoisted_11, [
          _createElementVNode("i", {
            class: "fa-solid fa-trash-can bg-red-500 text-white p-[10px] rounded-[5px] mr-[5px] text-xl cursor-pointer",
            onClick: ($event: any) => (confirmDelete(newsDetail))
          }, null, 8, _hoisted_12),
          _createElementVNode("i", {
            class: "fa-solid fa-file-pen bg-blue-500 text-white p-[10px] rounded-[5px] ml-[5px] text-xl cursor-pointer",
            onClick: ($event: any) => (confirmUpdate(newsDetail))
          }, null, 8, _hoisted_13)
        ])
      ]))
    }), 256)),
    (showConfirmationModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("p", null, "ID : " + _toDisplayString(selectedNewsDetail.value?.id), 1),
            _createElementVNode("p", null, "Titre : " + _toDisplayString(selectedNewsDetail.value?.title), 1),
            _createElementVNode("div", { class: "flex justify-end mt-6" }, [
              _createElementVNode("button", {
                class: "px-4 py-2 bg-red-500 text-white rounded mr-4",
                onClick: deleteNews
              }, "Supprimer"),
              _createElementVNode("button", {
                class: "px-4 py-2 bg-gray-300 rounded",
                onClick: cancelDelete
              }, "Annuler")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})